module.exports = __webpack_public_path__ + "img/bisiness.1e0a4f2b.png";